<template>
  <div class="px-1 d-flex flex-column h-100 sidebar-filters-wrapper">
    <!-- scroll -->
    <div class="flex-grow-1 overflow-auto pr-1">

      <div class="mb-2">
        <h5>{{ $t('ia.assistants.filters.formality') }}</h5>
        <b-form-checkbox-group
          v-model="filters.formalities"
          :options="$t('ia.formality')"
          stacked
        />
      </div>

      <div class="mb-2">
        <h5>{{ $t('ia.assistants.filters.bias') }}</h5>
        <b-form-checkbox-group
          v-model="filters.bias"
          :options="$t('ia.bias')"
          stacked
        />
      </div>

      <div class="mb-2">
        <h5>{{ $t('ia.assistants.filters.responseLength') }}</h5>
        <b-form-checkbox-group
          v-model="filters.response_length"
          :options="$t('ia.response_length')"
          stacked
        />
      </div>
    </div>

    <!-- Footer actions -->
    <div class="mt-auto py-1 d-flex justify-content-end actions-footer">
      <b-button variant="outline-secondary" @click="clearFilters">
        {{ $t('ia.assistants.filters.clearAll') }}
      </b-button>
      <b-button variant="primary" class="ml-1" @click="applyFilters">
        {{ $t('ia.assistants.filters.apply') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BFormCheckboxGroup, BButton } from 'bootstrap-vue';

export default {
  name: 'siderFilterAssistants',
  components: { BFormCheckboxGroup, BButton },
  props: {
    initial_filters: {
      type: Object,
      default: () => ({
        formalities: [],
        bias: [],
        response_length: []
      })
    }
  },
  data() {
    return {
      filters: {
        formalities: [...(this.initial_filters.formalities || [])],
        bias: [...(this.initial_filters.bias || [])],
        response_length: [...(this.initial_filters.response_length || [])]
      }
    }
  },
  watch: {
    initial_filters: {
      deep: true,
      handler(newVal) {
        this.filters = {
          formalities: [...(newVal.formalities || [])],
          bias: [...(newVal.bias || [])],
          response_length: [...(newVal.response_length || [])]
        };
      }
    }
  },
  methods: {
    clearFilters() {
      this.filters = {
        categories: [],
        formalities: [],
        bias: [],
        response_length: []
      };
      this.updateFilters();
    },
    applyFilters() {
      this.$emit('apply-filters', this.filters);
      this.$emit('close-sidebar');
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-filters-wrapper {
  height: 100%;
  min-height: 100%;
}
.actions-footer {
  border-top: 1px solid #ececec;
}
h5 {
  color: #495057;
  font-weight: 600;
  font-size: 0.95rem;
}
</style>